export const CurrencySymbol = [
  {
    'pair': 'EUR_USD',
    'symbol': '€',
    'fullName': 'Euro',
  },
  {
    'pair': 'INR_USD',
    'symbol': '₹',
    'fullName': null,
  },
  {
    'pair': 'BRL_USD',
    'symbol': 'R$',
    'fullName': null,
  },
  {
    'pair': 'PEN_USD',
    'symbol': 'S/.',
    'fullName': null,
  },
  {
    'pair': 'CHF_USD',
    'symbol': 'CHF',
    'fullName': null,
  },
  {
    'pair': 'KES_USD',
    'symbol': 'KSh',
    'fullName': null,
  },
  {
    'pair': 'USD_KZT',
    'symbol': '$',
    'fullName': null,
  },
  {
    'pair': 'NGN_USD',
    'symbol': '₦',
    'fullName': null,
  },
  {
    'pair': 'CNY_USD',
    'symbol': '¥',
    'fullName': null,
  },
  {
    'pair': 'PHP_USD',
    'symbol': '₱',
    'fullName': null,
  },
  {
    'pair': 'UAH_USD',
    'symbol': '₴',
    'fullName': null,
  },
  {
    'pair': 'USD_UAH',
    'symbol': '$',
    'fullName': null,
  },
  {
    'pair': 'RUB_USD',
    'symbol': '₽',
    'fullName': null,
  },
  {
    'pair': 'USD_NGN',
    'symbol': '$',
    'fullName': null,
  },
  {
    'pair': 'ILS_USD',
    'symbol': '₪',
    'fullName': null,
  },
  {
    'pair': 'TWD_USD',
    'symbol': 'NT$',
    'fullName': null,
  },
  {
    'pair': 'BGN_USD',
    'symbol': 'лв',
    'fullName': null,
  },
  {
    'pair': 'SAR_USD',
    'symbol': 'ر.س',
    'fullName': null,
  },
  {
    'pair': 'COP_USD',
    'symbol': 'COL$',
    'fullName': null,
  },
  {
    'pair': 'UGX_USD',
    'symbol': 'USh',
    'fullName': null,
  },
  {
    'pair': 'USD_EUR',
    'symbol': '$',
    'fullName': null,
  },
  {
    'pair': 'ZAR_USD',
    'symbol': 'R',
    'fullName': null,
  },
  {
    'pair': 'DKK_USD',
    'symbol': 'KR',
    'fullName': null,
  },
  {
    'pair': 'NZD_USD',
    'symbol': 'NZ$',
    'fullName': null,
  },
  {
    'pair': 'KZT_USD',
    'symbol': '₸',
    'fullName': null,
  },
  {
    'pair': 'MAD_USD',
    'symbol': 'م.د.',
    'fullName': null,
  },
  {
    'pair': 'THB_USD',
    'symbol': '฿',
    'fullName': null,
  },
  {
    'pair': 'PKR_USD',
    'symbol': '₨',
    'fullName': null,
  },
  {
    'pair': 'BOB_USD',
    'symbol': '$b',
    'fullName': null,
  },
  {
    'pair': 'TRY_USD',
    'symbol': '₺',
    'fullName': null,
  },
  {
    'pair': 'ARS_USD',
    'symbol': 'ARS$',
    'fullName': null,
  },
  {
    'pair': 'BDT_USD',
    'symbol': '৳',
    'fullName': null,
  },
  {
    'pair': 'MXN_USD',
    'symbol': 'Mex$',
    'fullName': null,
  },
  {
    'pair': 'SEK_USD',
    'symbol': 'kr',
    'fullName': null,
  },
  {
    'pair': 'HUF_USD',
    'symbol': 'Ft',
    'fullName': null,
  },
  {
    'pair': 'HRK_USD',
    'symbol': 'kn',
    'fullName': null,
  },
  {
    'pair': 'JPY_USD',
    'symbol': '¥',
    'fullName': null,
  },
  {
    'pair': 'AED_USD',
    'symbol': 'د.إ',
    'fullName': 'UAE dirham',
  },
  {
    'pair': 'CAD_USD',
    'symbol': 'C$',
    'fullName': null,
  },
  {
    'pair': 'AUD_USD',
    'symbol': 'A$',
    'fullName': null,
  },
  {
    'pair': 'EGP_USD',
    'symbol': '£',
    'fullName': null,
  },
  {
    'pair': 'MNT_USD',
    'symbol': '₮',
    'fullName': null,
  },
  {
    'pair': 'RON_USD',
    'symbol': 'lei',
    'fullName': null,
  },
  {
    'pair': 'IDR_USD',
    'symbol': 'Rp',
    'fullName': null,
  },
  {
    'pair': 'PLN_USD',
    'symbol': 'zł',
    'fullName': null,
  },
  {
    'pair': 'HKD_USD',
    'symbol': 'HKD',
    'fullName': null,
  },
  {
    'pair': 'VND_USD',
    'symbol': '₫',
    'fullName': null,
  },
  {
    'pair': 'GBP_USD',
    'symbol': '£',
    'fullName': null,
  },
  {
    'pair': 'CZK_USD',
    'symbol': 'Kč',
    'fullName': null,
  },
  {
    'pair': 'VES_USD',
    'symbol': 'Bs',
    'fullName': null,
  },
];

// 长语言语种 需特殊处理下拉框宽度
export const long_language = [
  'pt_PT',
  'ru_RU',
  'es_ES',
  'ms_MY',
  'fr_FR',
  'fil_PH',
  'pl_PL',
  'de_DE',
  'vi_VN',
];
